import i18n from '@/i18n/i18n'
import axios from '@/services/'
import { useGlobalStore } from '@/stores/global'
import { defineStore } from 'pinia'

export const usePublicServicesStore = defineStore('publicServices', {
  state: () => {
    return {
      categories: [],
      selectedCategory: null
    }
  },
  getters: {
    serviceIds() {
      if (!this.selectedCategory) return null
    },
    availableSchemas() {
      return [
        124,
        212,
        375,
        376,
        407,
        446,
        447,
        458,
        464,
        495,
        583,
        587,
        588,
        603,
        632,
        633,
        634,
        635,
        636,
        675,
        714,
        733,
        753,
        763,
        765,
        767,
        783,
        784,
        873,
        914,
        944,
        945,
        946,
        962,
        967,
        968,
        969,
        977,
        978,
        1104,
        1105,
        1040,
        939,
        941,
        942,
        432,
        'issue-qr-code',
        'search-for-appointment'
      ]
    }
  },
  actions: {
    async getCategories({ forceFetch = false, languageCode = 2 } = {}) {
      const globalStore = useGlobalStore()
      const additionalServices = []

      if (this.categories.length > 0) {
        if (!forceFetch) {
          return
        }
      }

      const data = await axios.get(`/api/getPublicCategories/${languageCode || 2}`)

      this.categories = data
        .map((category) => {
          // debugger
          const serviceNames = []
          category.servicesTransIds.forEach((s, index) => {
            if (s === null) {
              const { key } = JSON.parse(category.subCategoryServiceConfigs[index])
              const matchingAdditionalService = globalStore.additionalServices.find(
                (s) => s.key == key
              )

              const serviceNameT9nKey = matchingAdditionalService.TransValue

              additionalServices.push({
                key,
                serviceShortName: serviceNameT9nKey
              })

              serviceNames.push(serviceNameT9nKey)
            } else {
              serviceNames.push(this.getServiceName(s))
            }
          })

          const parsedCategoryConfig = JSON.parse(category.categoryConfig)

          const c = {
            ...category,
            servicesTransIdsAsString: category.servicesTransIds.map((s) => `${s}`),
            serviceMapping: category.servicesTransIds.map((id, index) => ({
              [id]: serviceNames[index]
            })),
            categoryConfig: {
              ...parsedCategoryConfig,
              englishDescription: null,
              arabicDescription: null
            },
            serviceShortName: serviceNames,
            slug: category.publicCategoryDesc.toLowerCase().split(' ').join('-')
          }

          return c
        })
        .sort((a, b) => a.lookupPublicCategoryId - b.lookupPublicCategoryId)
      console.info('categories fetched')
    },
    getServiceName(serviceId) {
      const globalStore = useGlobalStore()

      const service = globalStore.servicesList.find((c) => c.transactionId == serviceId)
      return service?.localizedServiceName
    },
    setCategory(category) {
      this.selectedCategory = category
    },
    async getServicesForCategory() {
      const globalStore = useGlobalStore()

      if (!this.selectedCategory) return []

      const { lookupPublicCategoryId } = this.selectedCategory
      const path = `/api/getPublicCategoryService/${lookupPublicCategoryId}`
      const data = await axios.get(path)

      if (Array.isArray(data) === false) return []

      const output = data.map((d) => {
        const subCategoryServiceConfig = JSON.parse(d.subCategoryServiceConfig) || {}
        const service = globalStore.servicesList.find((sl) => sl.transactionId == d.serviceTransId)
        // if there's no key, or no object at all, it means it's a normal service
        if (service) {
          return {
            ...d,
            ...service
          }
        }

        const addtlServiceObj = globalStore.additionalServices.find(
          (as) => as.key == subCategoryServiceConfig.key
        )

        const localizedServiceName = addtlServiceObj?.TransValue
          ? i18n.global.t(addtlServiceObj?.TransValue)
          : ''

        return {
          ...d,
          ...service,
          localizedServiceName,
          serviceId: null,
          transactionId: null,
          subCategoryServiceConfig: {
            ...subCategoryServiceConfig,
            key: subCategoryServiceConfig.key?.replaceAll('_', '-').toLowerCase() || '--'
          }
        }
      })

      return output
    }
  }
})
